const currentInput = ref<string | null>(null);
const usingMouse = computed(() => currentInput.value === 'mouse');
const usingTouch = computed(() => currentInput.value === 'touch');
const usingPen = computed(() => currentInput.value === 'pen');
let mountedCount = 0;

function onPointerDown(e: PointerEvent) {
  setInput(e.pointerType);
}

function onPointerMove(e: PointerEvent) {
  setInput(e.pointerType);
}

function setInput(type: string) {
  if (currentInput.value !== type) {
    currentInput.value = type;

    if (type != 'mouse') {
      window.addEventListener('pointermove', onPointerMove, { passive: true });
    } else {
      window.removeEventListener('pointermove', onPointerMove);
    }
  }
}

export function useInputTracker() {
  onMounted(() => {
    mountedCount++;
    window.addEventListener('pointerdown', onPointerDown, { passive: true });
    window.addEventListener('pointermove', onPointerMove, { passive: true });
  });

  onUnmounted(() => {
    mountedCount--;

    if (mountedCount == 0) {
      window.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('pointermove', onPointerMove);
    }
  });

  return {
    currentInput,
    usingMouse,
    usingTouch,
    usingPen
  };
}